var map = {
	"./c-1.png": "B7OC",
	"./c-2.png": "S1Eo",
	"./c-3.png": "ujSR",
	"./c-4.png": "2kj4"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "DSYf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nav ^\.\/c\-.*\.png$
// module id = DSYf
// module chunks = 1